import React, { Component } from 'react'



export class PolicyLink extends Component {
    constructor(props) {
        super(props);
        this.state = {
            kiplepay_merchant_id: null
        }
    }

    getKipplePayMerchant = () => {       
        if (window.showPrivacyPolicy) {
            const privacyPolicyUrl = this.props.app.getMerchantSettingValue('Kipple_Data') || "https://www.order-lah.com/privacypolicy.htm"
            const refundPolicyUrl = this.props.app.getMerchantSettingValue('Kipple_Refund') || "https://s1.order-lah.com/refundpolicy.htm"
            const tncUrl = this.props.app.getMerchantSettingValue('Kipple_tnc') || "https://s1.order-lah.com/tnc.htm"
            
            return (
                <div>
                     <br/>
                     <a href={tncUrl} target="_blank">
                    {lang.terms_condition}
                </a>
                <br/>
                <a href={privacyPolicyUrl} target="_blank">
                    {lang.privacy_policy}
                </a>
                <br/>
                <a href={refundPolicyUrl} target="_blank">
                    {lang.refund_policy}
                </a>
               
                </div>
            ) 
        }
        else{
           return (<div>
              
           </div>)
        }
    }


    render() {
        return (
            <div style={{textAlign:"center"}}>

                {this.getKipplePayMerchant()}
                
            </div>
        )
    }
}

export default PolicyLink
